
const w = window as any;

export const AnnounceKit = {
    init() {
        w.announcekit = (w.announcekit || {
            queue: [], on: function (n, x) {
                w.announcekit.queue.push([n, x]);
            }, push: function (x) { w.announcekit.queue.push(x); }
        });
    }
}